
import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_stock_levels: { message: "idle" },
};

export const retrieve_stock_levels_Slice = createSlice({
 name: "retrieve_stock_levels",
 initialState,
 reducers: {
  success_retrieve_stock_levels: (state, action) => {
   state.retrieve_stock_levels = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_stock_levels: (state, action) => {
   state.retrieve_stock_levels = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_stock_levels: (state) => {
   state.retrieve_stock_levels = { status: app_consts.IDLE };
  },
  loading_retrieve_stock_levels: (state) => {
   state.retrieve_stock_levels = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_stock_levels, fail_retrieve_stock_levels, reset_retrieve_stock_levels, loading_retrieve_stock_levels } = retrieve_stock_levels_Slice.actions;

export default retrieve_stock_levels_Slice.reducer;